import { useState, useRef, useContext } from "react"
import { client } from "../context/provider"
import AppContext from "../context"

function useImportDB () {
  const { loadBooks } = useContext(AppContext)
  const [ state, setState ] = useState({
    status: null,
    progress: null,
    error: null
  })
  const fileUploadRef = useRef(null)

  const logProgress = progress => {
    const percent = (progress.completedRows / progress.totalRows * 100).toFixed()
    setState({ ...state, status: 'IN-PROGRESS', progress: `${percent}%` })
  }

  const handleImport = evt => {
    evt.preventDefault()
    setState({ ...state, status: 'START' })
    const file = fileUploadRef.current.files[0]

    if (!file) {
      setState({ 
        ...state,
        status: 'FAIL',
        error: {
          message: 'Must choose a file!'
        }
      })
      return
    }

    client
      .import(file, logProgress)
      .then(result => {
        const newState = { ...state, status: result.status }
        if (result.error) {
          newState.error = result.error
        }
        setState(newState)
        loadBooks()
      })
      .catch(err => setState({
        ...state,
        status: 'FAIL',
        error: err,
      }))
  }

  return { state, handleImport, fileUploadRef }
}

export default useImportDB
